import type { ReactNode } from "react";
import { RequireAcl } from "@/components/RequireAcl";

/** Mein Bereich – Berechtigung kommt vom Server-ACL (`/personal/me.html`). */
export function RequirePersonalSelfService({ children }: { children: ReactNode }) {
  return <RequireAcl href="/personal/me.html">{children}</RequireAcl>;
}
